export const NodeElements = [
    'Banner',
    'InfoSection',
    'TenantSpecificComponent',
    'StaticInfoBlock',
    'ProductCatalogList',
    'DropDownMenuElementReference',
    'FooterDefinition',
    'EmptySlot',
    'FaqMarkup',
];
export const CategoryObjectType = {
    GridBlockElement: 'GridBlockElement',
    ProductCatalogList: 'ProductCatalogList',
    SectionHeaderElement: 'SectionHeaderElement',
    HomePage: 'HomePage',
    DropdownMenu: 'DropdownMenu',
    Info: 'Info',
    DropDownMenuElement: 'DropDownMenuElement',
};
